// extracted by mini-css-extract-plugin
export default {"pagination":"ITrb0","skeleton-placeholder-pulse":"IK_Fb","skeletonPlaceholderPulse":"IK_Fb"};